import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { formatPhoneNumber } from '../../utils'
import { Colors } from '../../styles/theme'
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import SyncIcon from '@mui/icons-material/Sync';
import { usePreferences } from 'hooks/usePreferences';
import { formatPhoneForDisplay } from '../../utils/phoneUtils';
import { formatDateWithPreferences } from '../../utils/dateFormatUtils';

function CustomerInfobar({ customerData, loadCustomer }) {
    const { preferences: businessPreferences } = usePreferences();
    const customerRecord = customerData?.customer || customerData || {};
    const customerName = customerRecord?.fullName || [customerRecord?.firstName, customerRecord?.lastName].filter(Boolean).join(' ').trim();
    const hasCustomerName = Boolean(customerName);
    const phoneDisplay = formatPhoneForDisplay(customerRecord?.mobile || customerRecord?.phone, businessPreferences).displayText;

    return (
        <Box display="flex" alignItems="center">
            <Box display="flex" alignItems="center">
                <Typography variant="h4" sx={{ color: Colors.dim_grey, textTransform: "capitalize", mr: 2 }}>
                    {hasCustomerName ? customerName : 'Customer'}
                </Typography>
                {
                    loadCustomer && customerRecord?.id && (<IconButton onClick={() => loadCustomer(customerRecord.id)}>
                        <Tooltip title="Refresh">
                            <SyncIcon fontSize="small" sx={{ ml: 1, color: Colors.dim_grey }} />
                        </Tooltip>
                    </IconButton>)
                }
            </Box>
            {
                customerRecord?.birthdate &&
                <>
                    <CalendarTodayIcon sx={{ fontSize: '0.75rem', mr: 1, color: Colors.dim_grey }} />
                    <Typography variant="caption" sx={{ color: Colors.dim_grey, textTransform: "capitalize" }}>
                        {formatDateWithPreferences(customerRecord.birthdate, businessPreferences)}
                    </Typography>
                    <Typography variant="caption" sx={{ ml: 1, color: Colors.dim_grey, textTransform: "capitalize" }}>
                        ({customerRecord.age} years)
                    </Typography>
                </>

            }
            <Typography component={"span"} variant="caption" sx={{ color: Colors.dim_grey, textTransform: "capitalize" }}>
                {customerRecord?.fullAddress || ''}
            </Typography>
            <LocalPhoneIcon fontSize="small" sx={{ fontSize: '0.75rem', ml: 1, color: Colors.dim_grey }} />
            <Typography component={"span"} variant="caption" sx={{ ml: 1, color: Colors.dim_grey }}>
                {phoneDisplay}
            </Typography>
        </Box>
    )
}

export default CustomerInfobar